import type { AllRouteEndpoints } from "../routeTypes";

export const campaignBrief = "/:app_group_id/campaign_brief/:campaign_id";

export const campaignBriefCacheKeys: AllRouteEndpoints[] = ["/:app_group_id/campaign_brief/:campaign_id"];

/**
 * The react-query key `useDashboardApiQuery` builds for the brief GET
 * (`[{ cacheKey, appGroupId }, ...params]`). Writers use it with
 * `queryClient.setQueryData` to publish a mutation response into the cache
 * synchronously, so readers see the fresh brief without waiting on the
 * refetch that the mutation adapter's invalidation kicks off in the background.
 */
export const getCampaignBriefQueryKey = (appGroupId: string, campaignId: string) => [
  { cacheKey: campaignBrief, appGroupId },
  { appGroupId, campaignId },
];
